import * as React from 'react';
import { ComponentProps, JSX } from 'react';
import { Box } from '@chakra-ui/react';

export const DragItem = ({
  children,
  ...props
}: { children: React.ReactNode } & ComponentProps<typeof Box>): JSX.Element => {
  return (
    <Box p={2} borderRadius="lg" {...props}>
      {children}
    </Box>
  );
};
